import { useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { Search } from "react-feather";

interface ILeapSearchProps {
  searchChangedFn: (newSearch: string) => void;
}

const LeapSearch = ({ searchChangedFn }: ILeapSearchProps) => {
  const borderColor = "#014891";
  const borderWidth = "2px";

  const [searchValue, setSearchValue] = useState("");
  const searchChanged = (newSearch: string) => {
    setSearchValue(newSearch);
    searchChangedFn(newSearch);
  };

  return (
    <div>
      <Row>
        <Col className="col-12">
          <InputGroup className="mb-3 input-group-navbar" size="lg">
            <Form.Control
              style={{
                borderColor: borderColor,
                borderStyle: "solid",
                borderRightStyle: "none",
                borderWidth: borderWidth,
              }}
              placeholder={"Search"}
              aria-label="Search"
              onChange={(e) => searchChanged(e.target.value)}
              value={searchValue}
            />
            <Button
              variant=""
              style={{
                borderColor: borderColor,
                borderStyle: "solid",
                borderLeftStyle: "none",
                borderWidth: borderWidth,
              }}
            >
              <Search
                className="feather"
                onClick={() => searchChanged(searchValue)}
              />
            </Button>
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};

export default LeapSearch;
